import { PaymentFrequency } from "@teams/types";
import React from "react";

const COUPON_CODE = "CYBER_MONDAY";

export function initCouponCode(): string {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("promoCode") === COUPON_CODE) {
    return COUPON_CODE;
  }
  return "";
}

export function initLicenses(): number {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("promoCode") === COUPON_CODE) {
    return 2;
  }
  return 1;
}

export function validateCoupon({
  couponCode,
  selectedLicenses,
  selectedFrequency,
}: {
  couponCode: string;
  selectedLicenses: number;
  selectedFrequency?: PaymentFrequency;
}): string | React.ReactNode | undefined {
  if (couponCode !== COUPON_CODE) {
    return undefined;
  }

  if (selectedFrequency !== "yearly") {
    return "The promo code can only be applied to annual subscriptions";
  }
  if (selectedLicenses < 2) {
    return "The promo code can only be applied when purchasing 2 or more licenses";
  }
  if (selectedLicenses > 6) {
    const msg = React.createElement(
      React.Fragment,
      null,
      "To purchase licenses in bulk, please reach out to our "
    );
    const link = React.createElement(
      "a",
      { href: "https://www.polly.ai/enterprise", target: "_blank" },
      "enterprise team"
    );
    return React.createElement(React.Fragment, null, [msg, link]);
  }

  return undefined;
}
